import { RouteRecordRaw } from 'vue-router';
import { PageDTO, PageRequestDTO } from '@/dto/page';
import { BaseDTO } from '@/request/apiConfig';
import myAxios from '@/request/myAxios';

const AUTH_CONTEXT_PATH = import.meta.env.VITE_AUTH_CONTEXT_PATH;

export const logRoutes: RouteRecordRaw[] = [
  {
    path: 'autoLog',
    name: 'AutoLog',
    component: () => import('./views/AutoLog.vue'),
  },
];

export interface AutoLogQuery extends PageRequestDTO {
  userNames: string[];
  userids: string[];
  startTimestamp: number;
  endTimestamp: number;
  paths: string[];
  actions: string[];
}

export interface AutoLogDTO {
  companyId: string;
  method: string;
  userName: string;
  userid: string;
  timestamp: number;
  path: string;
  content: string;
  body: any;
  query: any;
}

export interface AutoLogOption {
  name: string;
  text: string;
}

export interface AutoLogOptions {
  users: { [k: string]: string };
  options: AutoLogOption[];
}

export interface AutoLogPageDTO extends PageDTO<AutoLogDTO> {
  users: {
    [k: string]: string;
  };
}
export const apiLog = {
  query: (query: AutoLogQuery): Promise<BaseDTO<AutoLogPageDTO>> =>
    myAxios.post(`${AUTH_CONTEXT_PATH}/admin/log/query`, query),
  options: (): Promise<BaseDTO<AutoLogOptions>> =>
    myAxios.get(`${AUTH_CONTEXT_PATH}/admin/log/query/options`),
};
